import { Injectable } from '@angular/core';
import { OpinatorService } from '@core/services/core/opinator.service';
import { PollData } from '@models/poll-data';

@Injectable({
  providedIn: 'root'
})
export class OpinatorHelperService {

  constructor(
    private opinator: OpinatorService
  ) {}

  saveOpinatorParams(params: PollData, isPrivateArea: boolean) {
    this.opinator.pollData.area_type = isPrivateArea ? 'Logado' : 'Abierto';

    Object.entries(params).forEach(([field, value]) => {
      this.opinator.pollData[field] = value;
    });
  }
}
